import React, {useRef} from 'react';
import './sidebar.css'
import {ReactComponent as Slashes} from '../../assets/svg/slashes.svg'
import useOnClickOutside from "../../useOnClickOutside";
import Choose from "./icon/Choose";
import ChooseTrue from "./icon/ChooseTrue";
import MapSideBar from "../MapSideBar/MapSideBar";
import SidebarSection from "./sidebarSection";
import {ICoordinate} from "../../types/types";
import {ReactComponent as  Close} from "../../assets/svg/close.svg";
import useWindowDimensions from "../../hooks/useWindowDimentions";


const Sidebar = ({isActive, onClose, country, hoverInfo, continentMap, isSidebarOpen, coordinate}: {
  isActive: boolean,
  country: string, onClose: () => void, hoverInfo: string, continentMap: null | string,
  isSidebarOpen: boolean, coordinate: ICoordinate
}) => {
  const ref = useRef(null);
  useOnClickOutside(ref, isActive ? onClose: () => {})
  const { height } = useWindowDimensions();


  return (

    <div ref={ref} className={`sidebar-wrap ${isActive ? 'slide-in': ''}`} style={{height}}>
      <div className={'sidebar-relative-wrap'}>
<div onClick={onClose} className={'sidebar-close'}>
  <Close width={26} height={26} />
</div>
        <div className={'slashes-block'}>
          <p className={`sidebar-main-title ${isActive ? 'title-slide-in': 'title-slide-out'}`}>
            {country}
          </p>
          <div className={'slashes'}>
            <Slashes />
          </div>
          <div className={'sidebar-map'}>
            <MapSideBar hoverInfo={hoverInfo} country={country} continentMap={continentMap} coordinate={coordinate}/>
          </div>

          <div className={'sidebar-container'}>
            <div>
              <div className={'sidebar-select transition-all'}>
                {coordinate?.offices?.map((item,i) =>
                  <>
                  <SidebarSection  item={item} key={`sidebar-section + ${i}`}/>
                  </>
                )}
              </div></div>

          <div className={'section-footer'}>
            <div className={'section-footer-nav'}>
              <div className={'section-footer-nav-border'}>
                <div className={'section-footer-nav-slash'} />
                <div className={'section-footer-nav-slash2'} />
              </div>
              <div className={'section-footer-nav-items'} >
                <div className={'section-footer-nav-items-title'}>Offices and Distributors</div>
                <div className={'section-footer-nav-items-icon'}><ChooseTrue/></div>
              </div>
              <div className={'section-footer-nav-items'} >
                <div className={'section-footer-nav-items-title'}>Printers and Projects</div>
                <div className={'section-footer-nav-items-icon'}><Choose/></div>
              </div>
            </div>

          </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Sidebar;